import { FlexColumn } from "@/components/Flex";
import { AuthEvent } from "@/features/Auth/AuthPopup/utils/constants";
import { AuthEmailButton, AuthSignupSocialBtns } from "@/features/Auth/components/styled/SocialButtons";
import br from "@/styles/breakpoints.module.css";
import { themeColors } from "@/utils/themeColors";
import { ASSETS_URL } from "@/config/deployConstants";
import Image from "next/image";
import { spacing } from "@/utils/spacing";
import { borderRadius } from "@/utils/borderRadius";
import { OrDivider } from "@/features/Auth/components/styled/Separator";
import ClickableText from "@/components/styled/button/ClickableText";
import { useAuthSlideContextSelector } from "@/features/Auth/AuthSlide/hook/useAuthSlideContext";
import Link from "@/components/wrappers/Link";

const SignupPopup = ({ event }: { event: AuthEvent }) => {
    const openAuthSlide = useAuthSlideContextSelector(state => state.openAuthSlide);

    const getTitleText = () => {
        switch (event) {
            case AuthEvent.FLASHCARD_LIST_CONVERTER:
                return "Create an account or sign in to access the rest!";
            case AuthEvent.NOTE_EDITOR_FLOATING:
                return "Create an account or sign in to see this note!";

            default:
                return "Create an account or sign in to continue!";
        }
    };

    return (
        <FlexColumn
            style={{
                padding: "3rem",
                backgroundColor: themeColors.neutralWhite,
                gap: spacing.MD_S,
                borderRadius: borderRadius.largeModal,
            }}>
            <Image
                src={`${ASSETS_URL}/images/knowt-logo.svg`}
                alt="Knowt Logo"
                width={120}
                height={60}
                style={{ objectFit: "contain" }}
            />
            <FlexColumn
                style={{
                    gap: "1.5rem",
                    alignItems: "center",
                    maxWidth: "40rem",
                }}>
                <span className="bodyBold1" data-testid="auto-id-39a9b8c4-f725-4d21-bafb-220cb2794134">
                    {getTitleText()}
                </span>

                <AuthSignupSocialBtns event={event} style={{ width: "100%" }} />

                <OrDivider />

                <AuthEmailButton showText onClick={() => openAuthSlide({ showSignupPage: true, event })} />

                <ClickableText className="bodyBold2" onClick={() => openAuthSlide({ showLoginPage: true })}>
                    Already have an account? Log In
                </ClickableText>

                <span
                    className="secondaryText2"
                    style={{
                        textAlign: "center",
                        maxWidth: "26.8rem",
                        margin: "auto",
                        color: themeColors.neutral2,
                    }}
                    data-testid="auto-id-38ac7912-0a39-4070-8850-5704bbb161d2">
                    {"By signing up you agree to our "}
                    <Link
                        href="/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "inherit", textDecoration: "underline", fontWeight: "600" }}
                        data-testid="auto-id-38af8130-a0f9-420c-afdf-e4fede4746b1">
                        {"Terms of Service"}
                    </Link>
                    {" and "}
                    <Link
                        href="/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "inherit", textDecoration: "underline", fontWeight: "600" }}
                        data-testid="auto-id-15bf01f4-ceb6-4c64-b558-b362190598ae">
                        {"Privacy Policy"}
                    </Link>

                    {/* MOBILE GAP FOR BOTTOM OVERLAY BROWSER TAB */}
                    <div
                        className={br.smUpDisplayNone}
                        style={{ paddingBottom: "5rem" }}
                        data-testid="auto-id-d5f65f83-e087-4bc3-985c-beb97bc0ed8d"
                    />
                </span>
            </FlexColumn>
        </FlexColumn>
    );
};

export default SignupPopup;
